import React, {Component} from 'react';
import * as func from "../../../../utils/functions";

class journal extends Component {
	constructor(props) {
		super(props);

    let today = new Date();

		this.state = {
		  // show : '',
      action : 'analytics/journal',
      records : [],
      param : {
        anal_type : '',
        indicator_year : today.getFullYear() - 1,
        output_style : 'journal',
        col : '',
        dept : '',
        ranking : '',
        col_id : '',
        dept_id : '',
      },
      dept : [],
      deptKeyLabel : {},
      dept_depth1 : [],
      dept_depth2 : [],
      analytics : []
      // dept_depth3 : [],
    }

    this.onChange = this.onChange.bind(this)
    this.onChangeValue = this.onChangeValue.bind(this)
    this.getAnalytics = this.getAnalytics.bind(this)
  }

	componentDidMount() {
    func.getData("category/dept", null).then((response) => {
      const deptKeyLabel = {}
      response.records.map((d, index) => {
        deptKeyLabel[d.category_id] = d.category_name
      })
      this.setState({
        dept : response.records,
        deptKeyLabel : deptKeyLabel
      }, () => {
        this.setDepth();
      })
    })
  }

  setDepth() {
    let depth1 = [];
    let depth2 = [];

    if (this.state.dept.length > 0) {
      depth1 = this.getChildDepth(0)

      if (this.state.param.col_id) { depth2 = this.getChildDepth(this.state.param.col_id) }

      this.setState({
        dept_depth1 : depth1,
        dept_depth2 : depth2,
      })
    }
  }

  getChildDepth(parent_id) {
    return this.state.dept.filter(f => f.up_category_id == parent_id)
  }

  onChange = () => {
    let param = this.state.param;
    param[event.target.name] = event.target.value;
    this.setState({param:param})
    if (event.target.name === 'col_id' ) {
      this.setDepth()
      this.dept_id.value = ''
    }
    this.forceUpdate()
  }

  onChangeValue = (value) => {
    let param = this.state.param;
    param[event.target.name] = value;
    this.setState({param:param})
    this.forceUpdate()
  }

  getAnalytics () {
    func.getData(this.state.action + "/" + 'view' , this.state.param).then((response) => {
      let analytics = this.state.analytics
      let analytic = {
        'total' : response.total,
        'condition' : response.condition,
        'summary' : response.summary,
        'request_query' : response.request_query,
      }
      analytics.push(analytic)
      this.setState({
        analytics : analytics,
      })
    })
  }

	render() {

		return (
			<>
        <div className="mt-3">
          <h6 className="mb-2">분석유형</h6>
          <div className="input-group mb-2">
            <div className="form-check form-check-inline mr-3">
              <input className="form-check-input" type="radio" id="type_jcr" name="anal_type"
                     value="jcr"
                     checked={this.state.param.anal_type === 'jcr'}
                     onChange={()=>this.onChangeValue('jcr')}/>
              <label className="form-check-label" htmlFor="type_jcr">JCR</label>
            </div>
            <div className="form-check form-check-inline mr-3">
              <input className="form-check-input" type="radio" id="type_dept" name="anal_type"
                     value="dept"
                     checked={this.state.param.anal_type === 'dept'}
                     onChange={()=>this.onChangeValue('dept')}/>
              <label className="form-check-label" htmlFor="type_dept">학과별(준비중)</label>
            </div>
          </div>

          {this.state.param.anal_type === 'jcr' &&
          <div className="jcr-detail">
            <h6 className="mt-4 for-jcr">JCR 세부 선택</h6>
            <div className="row">
              <div className="col-md-2 form-group">
                <label htmlFor="journal_title"><strong>등재 연도</strong></label>
                <div>
                  <input type="text" name="indicator_year" className="form-control" value={this.state.param.indicator_year}
                        onChange={this.onChange}/>
                </div>
              </div>
              <div className="col-md-5 form-group">
                <label htmlFor="jcr_output"><strong>반출 기준</strong></label>
                <div className="input-group mb-2">
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="radio" id="output_journal" name="output_style"
                           checked={this.state.param.output_style === 'journal'}
                           value="journal" onChange={this.onChange}/>
                    <label className="form-check-label" htmlFor="output_journal">저널 기준</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="radio" id="output_ranking" name="output_style"
                           checked={this.state.param.output_style === 'ranking'}
                           value="ranking" onChange={this.onChange}/>
                    <label className="form-check-label" htmlFor="output_ranking">카테고리 랭킹기준</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }

          {this.state.param.anal_type === 'dept' &&
          <div className="dept-detail">
            <h6 className="mt-4 for-jcr">Dept 세부 선택</h6>
            <div className="row">
              <div className="col-md-2 form-group">
                <label htmlFor="col"><strong>단대</strong></label>
                <div>
                  {/*<select className="form-select form-control mr-4" name="col" id="col"*/}
                  {/*  onChange={this.onChange}>*/}
                  {/*  <option value=''>전체</option>*/}
                  {/*  <option value="1">공과대학</option>*/}
                  {/*  <option value="2">사범대학</option>*/}
                  {/*  <option value="3">자연과학대학</option>*/}
                  {/*  <option value="4">인문대학</option>*/}
                  {/*</select>*/}
                  <select className="form-control form-control-sm"
                          value={this.state.param.col_id || ""}
                          ref={(ref)=>this.col_id=ref}
                          name="col_id"
                          onChange={this.onChange}>
                    {this.state.dept_depth1.length != 0 ?
                        <option value="">단과 대학를 선택해주세요.</option> :
                        <option value="">단과 대학이 없습니다.</option>}
                    {this.state.dept_depth1.map((type, i) => {
                      return (<option key={type.category_id} value={type.category_id}>{type.category_name}</option>)
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-2 form-group">
                <label htmlFor="col"><strong>학과</strong></label>
                <div>
                  {/*<select className="form-select form-control mr-4" name="dept" id="dept"*/}
                  {/*        onChange={this.onChange}>*/}
                  {/*  <option value="">전체</option>*/}
                  {/*  <option value="1">기계공학부</option>*/}
                  {/*  <option value="2">항공우주공학부</option>*/}
                  {/*</select>*/}
                  <select className="form-control form-control-sm"
                          value={this.state.param.dept_id || ""}
                          ref={(ref)=>this.dept_id=ref}
                          name="dept_id"
                          onChange={this.onChange}>
                    {this.state.dept_depth2.length != 0 ?
                        <option value="">학과를 선택해주세요.</option> :
                        <option value="">하위 학과가 없습니다.</option>}
                    {this.state.dept_depth2.map((type, i) => {
                      return (<option key={type.category_id} value={type.category_id}>{type.category_name}</option>)
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-2 form-group">
                <label htmlFor="col"><strong>상위 기준</strong></label>
                <div>
                  <select className="form-select form-control mr-4" name="ranking" id="ranking"
                          onChange={this.onChange}>
                    <option value="">전체</option>
                    <option value="jcr_1">JCR 기준 상위 1%</option>
                    <option value="jcr_10">JCR 기준 상위 10%</option>
                    <option value="jcr_30">JCR 기준 상위 30%</option>
                    <option value="jcr_50">JCR 기준 상위 50%</option>
                    <option value="scopus_1">Scopus 기준 상위 1%</option>
                    <option value="scopus_10">Scopus 기준 상위 10%</option>
                    <option value="scopus_30">Scopus 기준 상위 30%</option>
                    <option value="scopus_50">Scopus 기준 상위 50%</option>
                    <option value="kci_1">KCI 기준 상위 1%</option>
                    <option value="kci_10">KCI 기준 상위 10%</option>
                    <option value="kci_30">KCI 기준 상위 30%</option>
                    <option value="kci_50">KCI 기준 상위 50%</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          }

          {this.state.param.anal_type &&
            <>
              <hr/>
              <div className="row mt-2">
                <div className="col-12 d-flex justify-content-center">
                  <button type="button" className="btn btn-primary" onClick={this.getAnalytics}>검색</button>
                </div>
              </div>
            </>
          }
        </div>

        {/*<div className="card maxWidthInit p-0 hide hidden">*/}
        {/*  <div className="card-header">*/}
        {/*    저널 분석*/}
        {/*  </div>*/}
        {/*  <div className="card-body">*/}
        {/*    <div className="row mb-2">*/}
        {/*      <div className="col-md-7">*/}
        {/*        <div className="form-group">*/}
        {/*          <label><strong>연구자 검색</strong></label>*/}
        {/*          <div className="input-group">*/}
        {/*            <input type="text" className="form-control" onChange={this.onChange} />*/}

        {/*            <button type="button" className="btn btn-outline-secondary btn-sm">*/}
        {/*            검색*/}
        {/*            </button>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="col-md-5">*/}
        {/*        <div className="form-group">*/}
        {/*          <label><strong>년도</strong></label>*/}
        {/*          <div className="input-group">*/}
        {/*            <input type="text" className="form-control" value="" onChange={this.onChange} />*/}
        {/*            <span className="input-group-text">~</span>*/}
        {/*            <input type="text" className="form-control" value="" onChange={this.onChange} />*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className="row mb-2">*/}
        {/*      <div className="col-md-12 form-group">*/}
        {/*        <label htmlFor="journal_title"><strong>신분</strong></label>*/}
        {/*        <div className="input-group">*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" onChange={this.onChange} checked />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox1">교수</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox2">기금교수</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox3" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox3">HK교수</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox4" value="option3" onChange={this.onChange} checked />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox4">명예교수</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox5" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox5">기타교수</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox6" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox6">병원교수</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox7" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox7">연구원</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox8" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox8">강사</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox9" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox9">대학원생</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox10" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox10">직원</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline mr-3">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox11" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox11">조교</label>*/}
        {/*          </div>*/}
        {/*          <div className="form-check form-check-inline">*/}
        {/*            <input className="form-check-input" type="checkbox" id="inlineCheckbox12" value="option3" onChange={this.onChange} />*/}
        {/*            <label className="form-check-label" htmlFor="inlineCheckbox12">학부생</label>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className="row mb-2">*/}
        {/*      <div className="col-md-7">*/}
        {/*        <div className="form-group">*/}
        {/*          <label><strong>단과 및 학과</strong></label>*/}
        {/*          <div className="input-group">*/}
        {/*            <select className="form-select mr-4">*/}
        {/*              <option selected="selected">전체</option>*/}
        {/*              <option value="1">공과대학</option>*/}
        {/*              <option value="2">사범대학</option>*/}
        {/*              <option value="3">자연과학대학</option>*/}
        {/*              <option value="4">인문대학</option>*/}
        {/*            </select>*/}
        {/*            <select className="form-select mr-4">*/}
        {/*              <option selected="selected">전체</option>*/}
        {/*              <option value="1">고분자공학과</option>*/}
        {/*              <option value="2">재료공학부</option>*/}
        {/*              <option value="3">전자공학과</option>*/}
        {/*            </select>*/}
        {/*            <select className="form-select mr-4">*/}
        {/*              <option selected="selected">전공</option>*/}
        {/*            </select>*/}

        {/*            <button type="button" className="btn btn-primary btn-sm">*/}
        {/*              추가*/}
        {/*            </button>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className="card-footer text-right">*/}
        {/*    <button type="button" className="btn btn-primary btn-sm">*/}
        {/*      검색*/}
        {/*    </button>*/}
        {/*  </div>			*/}
        {/*</div>*/}
    
        <div className="mt-5">
          <table className="table table-striped table-thin border-bottom">
            <colgroup>
              <col width="400px"/>
              <col width="100px"/>
              <col width="auto"/>
              <col width="80px"/>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">분석조건</th>
                <th scope="col">결과</th>
                <th scope="col">요약</th>
                <th scope="col">액션</th>
              </tr>
            </thead>
            <tbody>
            {this.state.analytics && this.state.analytics.map((record, index) => {
              return(
                <tr key={index}>
                  <td>{record.condition}</td>
                  <td>{func.getNumberFormat(record.total)}</td>
                  <td>{record.summary ? record.summary : ' '}</td>
                  <td><a href={rmVars.restApi + this.state.action + "/" + 'download?' + func.objectToQueryString(record.request_query)} target="_blank" className="btn btn-outline-dark btn-sm">다운로드</a></td>
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>
			</>
		)
	}
}

export default journal;
